import React, { useMemo, useState } from "react";
import PageShell from "../dashboard/PageShell";

const TransferResponsible: React.FC = () => {
  const id = useMemo(() => {
    try {
      const parts = window.location.pathname.split("/").filter(Boolean);
      // expected: topics/approval/detail/:id/transfer → id at index length-2
      return parts[parts.length - 2] || "";
    } catch {
      return "";
    }
  }, []);

  const [form, setForm] = useState({
    mainAccount: "",
    coAccount: "",
  });

  const change = (field: string, value: string) =>
    setForm((p) => ({ ...p, [field]: value }));

  return (
    <PageShell title="Chuyển phụ trách">
      <div className="space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Chuyển phụ trách
          </h1>
        </div>

        {/* Topic header */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 text-sm">
            <div>
              <div className="text-gray-800 font-medium">Đề tài:</div>
              <div className="text-gray-700">
                Nghiên cứu phần mềm quản lý KHCN có ứng dụng AI
              </div>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="bg-white rounded-lg p-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-center">
            <select
              value={form.mainAccount}
              onChange={(e) => change("mainAccount", e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md"
            >
              <option value="">demo@rnet.vn</option>
              <option value="user1@rnet.vn">user1@rnet.vn</option>
              <option value="user2@rnet.vn">user2@rnet.vn</option>
            </select>
            <select
              value={form.coAccount}
              onChange={(e) => change("coAccount", e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md lg:col-span-2"
            >
              <option value="">- Chọn tài khoản phụ trách cùng -</option>
              <option value="user3@rnet.vn">user3@rnet.vn</option>
              <option value="user4@rnet.vn">user4@rnet.vn</option>
            </select>
            <div className="lg:col-span-3 flex justify-end gap-2">
              <button
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
                onClick={() => window.history.back()}
              >
                Hủy
              </button>
              <button
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm font-medium"
                onClick={() => {
                  console.log("Transfer responsible", form);
                  const projectId =
                    id || window.location.pathname.split("/")[4];
                  window.location.href = `/topics/approval/detail/${projectId}`;
                }}
              >
                Lưu dữ liệu
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default TransferResponsible;
